import { Link } from "react-router-dom";
import { ChevronRight, AlertTriangle, AlertCircle, Info, Zap } from "lucide-react";

const SEVERITY_STYLES = {
  critical: { icon: AlertTriangle, color: "text-red-600", bg: "bg-red-50 hover:bg-red-100", border: "border-red-200" },
  important: { icon: AlertCircle, color: "text-amber-600", bg: "bg-amber-50 hover:bg-amber-100", border: "border-amber-200" },
  informative: { icon: Info, color: "text-blue-600", bg: "bg-blue-50 hover:bg-blue-100", border: "border-blue-200" },
};

function formatImpact(amount) {
  if (amount >= 1000) {
    return `${(amount / 1000).toFixed(1)}k€`;
  }
  return `${amount.toFixed(0)}€`;
}

export default function ActionCards({ actions }) {
  if (!actions || actions.length === 0) {
    return (
      <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 flex items-center gap-3">
        <Zap className="w-5 h-5 text-emerald-600" />
        <p className="text-sm font-medium text-emerald-900">Sin acciones pendientes — todo bajo control</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {actions.map((action, i) => {
        const style = SEVERITY_STYLES[action.severity] || SEVERITY_STYLES.informative;
        const Icon = style.icon;
        return (
          <Link
            key={`${action.tension_id}-${i}`}
            to={action.link || "#"}
            className={`block ${style.bg} border ${style.border} rounded-lg p-3 transition-colors`}
          >
            <div className="flex items-center gap-3">
              <Icon className={`w-4 h-4 ${style.color} shrink-0`} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h4 className="text-sm font-semibold text-slate-900 truncate">{action.title}</h4>
                  {action.estimated_impact_eur > 0 && (
                    <span className="text-xs px-1.5 py-0.5 rounded bg-slate-200 text-slate-700 font-mono shrink-0">
                      ~{formatImpact(action.estimated_impact_eur)}
                    </span>
                  )}
                </div>
                <p className="text-xs text-slate-600 mt-0.5">{action.action}</p>
              </div>
              <ChevronRight className="w-4 h-4 text-slate-400 shrink-0" />
            </div>
          </Link>
        );
      })}
    </div>
  );
}
